"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildMentionNode = buildMentionNode;
exports.createMentionDeserializerPlugin = void 0;
var _plateCommon = require("@udecode/plate-common");
var _plateMention = require("@udecode/plate-mention");
var MENTION_DESERIALIZER_PLUGIN_KEY = 'mention-deserializer-plugin';
function buildMentionNode(value, label) {
  return {
    value: value,
    label: label,
    type: _plateMention.ELEMENT_MENTION
  };
}
var createMentionDeserializerPlugin = exports.createMentionDeserializerPlugin = (0, _plateCommon.createPluginFactory)({
  key: MENTION_DESERIALIZER_PLUGIN_KEY,
  deserializeHtml: {
    getNode: function getNode(element) {
      var _element$getAttribute;
      var value = (_element$getAttribute = element.getAttribute('data-slate-value')) !== null && _element$getAttribute !== void 0 ? _element$getAttribute : '';
      var label = element.innerText;
      return buildMentionNode(value, label);
    },
    isElement: true,
    rules: [{
      validClassName: 'slate-mention',
      validAttribute: 'data-slate-value'
    }]
  }
});